module.exports = __webpack_public_path__ + "01_medium_black.f990e4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_medium_black.png
// module id = 2NL5
// module chunks = 0